import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import deviceInfo from 'APP/packages/deviceInfo';

const hasAudioPermissions = async (checkMicrophone = true) => {
  const { hasSpeaker } = await deviceInfo.getMediaDevices();

  if (!hasSpeaker) {
    Tasks.app.showAlert(t('calls_no_dynamic_connected'));

    return false;
  }

  if (!checkMicrophone) {
    return true;
  }

  return await Tasks.permissions.hasMicrophonePermission();
};

export default hasAudioPermissions;
